<script>
import { mapActions } from 'vuex';
import request from '@/services/request';
import ModalFormComponent from '@/components/banking_service_payments/ModalBankingServicesPayments.vue';
import ModalFormRulesComponent from '@/components/bill/ModalFormRuleComponent.vue';

export default {
    name: "BankingServicePaymentsList",

    components: {
        ModalFormComponent,
        ModalFormRulesComponent
    },

    data() {
        return {
            load: false,
            payments: [],
            editBill: false,
            search: {
                payable_type_id: '',
                provider_id: '',
                bank_account_id: '',
                payment_date_from: '',
                payment_date_to: '',
            },
        };
    },

    methods: {
        closedModal() {
            this.$modal.hide('SelectPay');
        },
        newPayment() {
            this.$modal.show('SelectPay');
        },
        deletePayment(id) {
            let tit = 'Eliminar pago';
            let txt = 'Seguro que quiere eliminar el pago';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/banking-service-payments/' + id;

                    try {
                        let response = await request.destroy(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },


        async list(page = 1) {
            this.load = true;

            let _endpoint = '/banking-service-payments';

            try {
                let { data } = await request.list(_endpoint, page, this.search);

                this.payments = data;

                this.load = false;
            } catch (error) {
                this.load = false;
                this.errors = {};
                this.errors = await this.errorNotification(error);
            }
        },

        openCreateModalBill(payment = {}) {
            this.closedModal();
            this.editBill = true;
            if (payment.bill) {
                this.editBill = false;
            }
            Event.$emit('event-show-addBillRules', payment);
        },

        openCreateModal(payment = {}) {
            this.closedModal();
            Event.$emit('event-show-banking-service-payment', payment);
        },

        getPayableTypeName(type) {
            const value = parseInt(type);

            if (value === 1) {
                return 'Cuenta bancaria';
            }

            if (value === 2) {
                return 'Proveedor';
            }

            return 'No definido';
        },

        getBankAccountName(payment) {
            if (!payment.bank_account) {
                return 'Cuenta no encontrada';
            }

            let name = payment.bank_account.name || '';

            if (payment.bank_account.bank) {
                name += ' / ' + payment.bank_account.bank.name;
            }

            if (payment.bank_account.number) {
                name += ' - ' + payment.bank_account.number;
            }

            return name;
        },

        getProviderName(payment) {
            if (!payment.provider) {
                return 'Proveedor no encontrado';
            }

            return `${payment.provider.name || ''} ${payment.provider.last_name || ''}`;
        },

        getPayableName(payment) {
            if (parseInt(payment.payable_type_id) === 1) {
                return this.getBankAccountName(payment);
            }

            if (parseInt(payment.payable_type_id) === 2) {
                return this.getProviderName(payment);
            }

            return 'S/N';
        },

        cleanSearch() {
            this.search = {
                payable_type_id: '',
                provider_id: '',
                bank_account_id: '',
                payment_date_from: '',
                payment_date_to: '',
            };

            this.list();
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },

    mounted() {
        this.list();
    },

    created() {
        Event.$on('event-reload-banking-service-payment', async () => {
            this.list();
        });
    },
};
</script>

<template>
    <div>
        <ModalFormComponent />
        <ModalFormRulesComponent :prop_edit="editBill" />

        <div class="card card-outline card-navy">
            <div class="card-header">
                <h3 class="card-title">
                    Pagos de servicios bancarios
                </h3>

                <div class="card-tools">
                    <button class="btn btn-sm btn-outline-info" @click="newPayment">
                        <i class="fa fa-plus"></i>
                        Nuevo pago
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="row mb-3">
                    <div class="col-md-3">
                        <label>Tipo</label>
                        <select class="form-control" v-model="search.payable_type_id" @change="list()">
                            <option value="">Todos</option>
                            <option :value="1">Cuenta bancaria</option>
                            <option :value="2">Proveedor</option>
                        </select>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-bordered text-center text-sm">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Tipo</th>
                                <th>Cuenta / Proveedor</th>
                                <th>Fecha de pago</th>
                                <th>Tipo de pago</th>
                                <th>Monto</th>
                                <th>Observación</th>
                                <th>Registró</th>
                                <th width="130">Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-if="load">
                                <td colspan="9" class="text-center">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>

                            <tr v-else-if="payments.data.length === 0">
                                <td colspan="9" class="text-center">
                                    No hay pagos registrados.
                                </td>
                            </tr>

                            <tr v-show="payments.data.length > 0" v-for="payment in payments.data" :key="payment.id">
                                <td>{{ payment.id }}</td>

                                <td>
                                    <span class="badge"
                                        :class="payment.payable_type_id == 1 ? 'badge-info' : 'badge-secondary'">
                                        {{ getPayableTypeName(payment.payable_type_id) }}
                                    </span>
                                </td>

                                <td>
                                    {{ getPayableName(payment) }}
                                </td>

                                <td>
                                    {{ payment.payment_date | toDateTime }}
                                </td>

                                <td>
                                    {{ payment.type_payment ? payment.type_payment.name : 'S/N' }}
                                </td>

                                <td>
                                    {{ payment.amount | toCurrency }}
                                </td>

                                <td>
                                    {{ payment.observation || 'S/N' }}
                                </td>

                                <td>
                                    {{ payment.created_at | toDateTime }}
                                </td>

                                <td>
                                    <button class="btn m-1 btn-outline-primary btn-sm" v-if="payment.payable_type_id == 1"
                                        @click="openCreateModal(payment)">
                                        <i class="fa fa-eye"></i>
                                        Ver
                                    </button>
                                    <button class="btn m-1 btn-outline-primary btn-sm" v-if="payment.payable_type_id == 2"
                                        @click="openCreateModalBill(payment)">
                                        <i class="fa fa-eye"></i>
                                        Ver
                                    </button>

                                    <button class="btn m-1 btn-outline-danger btn-sm"
                                        @click="deletePayment(payment.id)">
                                        <i class="fa fa-trash"></i>
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <!-- Modal selección tipo de pago -->
            <modal name="SelectPay" v-bind:click-to-close="false" :width="'400px'" :height="'auto'">
                <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                        class="fa-solid fa-xmark"></i> </button>
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Tipo de pago</h5>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-app bg-secondary btn-block" @click="openCreateModal()">
                                <i class="fas fa-solid fa-money-check-dollar f-30"></i> Cuenta de banco
                            </button>

                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-app bg-secondary btn-block" @click="openCreateModalBill()">
                            <i class="fas fa-user f-30"></i> Proveedor
                            </button>
                        </div>

                    </div>
                </div>
            </modal>

        </div>
    </div>
</template>
<style scoped>
.btn-app {
    margin: 0px;
    height: 80px;
}

.f-30 {
    font-size: 30px;
}
</style>